import { useContext } from 'react';
import { UnsavedFormContext } from '../context/UnsavedFormContext';

const useUnsaved = () => {
  return useContext(UnsavedFormContext);
};

export default useUnsaved;
